import AdminNexusHttpClient from './admin-nexus-http-client'

export default class FAQService {
  constructor() {
    this.httpClient = new AdminNexusHttpClient('/admin/faqs')
  }

  async get(property) {
    return await this.httpClient.get(`${property}`, {})
  }

  async set(payload) {
    return await this.httpClient.post('', payload)
  }
}
